import type { Dispatch, Model, SubscriptionAPI } from 'dva';

export type SagaResumeValue = unknown;
export type ModelSaga = Generator<unknown, void, SagaResumeValue>;

export function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

export interface EffectAction {
  readonly type?: string;
  readonly payload?: unknown;
}

export interface ModelCommands {
  readonly put: Dispatch;
  readonly select: <Selected>(selector: (state: never) => Selected) => unknown;
  readonly call: (...args: unknown[]) => unknown;
  readonly [name: string]: unknown;
}

export interface ReducerAction<Payload> {
  readonly type?: string;
  readonly payload: Payload;
}

export interface TypedModel<State> {
  readonly namespace: string;
  readonly state: State;
  readonly subscriptions?: Readonly<
    Record<string, (api: SubscriptionAPI, done?: () => void) => void>
  >;
  readonly effects?: Readonly<
    Record<string, (action: EffectAction, commands: ModelCommands) => ModelSaga | void>
  >;
  readonly reducers?: Readonly<
    Record<string, (state: State, action: ReducerAction<Partial<State>>) => State>
  >;
}

export function asDvaModel<State>(model: TypedModel<State>): Model {
  return model as unknown as Model;
}
